import React from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {useLanguage} from "../../i18n";

type LinkProps = {
    href: string;
    children?: React.ReactNode;
}

export function ExternalLink (props: LinkProps): React.ReactElement {
    const l = useLanguage();
    return (
        <a href={props.href}
           target="_blank"
           rel="noopener"
           title={props.href}
        >
            {props.children}
                <OpenInNewIcon
                    role="img"
                    className="open-in-new"
                    aria-label={l('uu.openNewWindow')}
                    titleAccess={l('uu.openNewWindow')}
                />
        </a>
    )
}